import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import dateFormat from '../../../utils/dateFormat';
import useStyles from './styles';

const campaignTypesTranslations = {
  'Form': 'ANALYTICS.CAMPAIGN_TYPES.FORM',
};

const SimpleList = ({ data }) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return data.map(row => {
    const isActive = row.active && new Date() <= new Date(row.dateEnd);
    const status = isActive
      ? t('ANALYTICS.CAMPAIGN_STATUS.ACTIVE')
      : t('ANALYTICS.CAMPAIGN_STATUS.FINISHED');
    const endDate = dateFormat(row.dateEnd);
    const campaignType = campaignTypesTranslations[row.type] || row.type;
    return (
      <div key={row.id} className={classes.simpleItem}>
        <div className={classes.primaryText}>
          <span className={classes.campaignName}>{row.name}</span>
          <span className={classes.campaignType}>{t(campaignType)}</span>
        </div>
        <div className={classes.secondaryText}>
          {isActive
            ? t('ANALYTICS.CAMPAIGN_STATUS.ACTIVE_LABEL', { date: endDate })
            : t('ANALYTICS.CAMPAIGN_STATUS.FINISHED_LABEL', { date: endDate })
          }
          <span style={{ color: isActive ? 'green' : 'red' }}>
            {status}
          </span>
        </div>
      </div>
    );
  });
};


SimpleList.propTypes = {
  data: PropTypes.array.isRequired,
};

export default SimpleList;
